var _style, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachinesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71,31 71,33 73,33 73,59 37,59 37,33 39,33 39,31 35,31 35,61 75,61 75,31 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    className: "st0",
    width: 30,
    height: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 21,
    className: "st1",
    width: 2,
    height: 26.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachinesDefault);
export default __webpack_public_path__ + "static/media/machines-default.74d82c7eaaa5dee6143b7879586e40f1.svg";
export { ForwardRef as ReactComponent };